import { useCallback } from 'react';
import { trackUserAction } from './trackUserAction';

/**
 * React hook wrapper around trackUserAction with a stable callback reference.
 */
export const useTrackUserAction = () => {
  const track = useCallback(
    (params: Record<string, unknown>) => trackUserAction(params),
    [],
  );

  return { trackUserAction: track };
};
